import PropTypes from 'prop-types';

export default function ColorScheme() { }

const COLORS = [
  null,
  'default',
  'primary',
  'secondary',
  'tertiary',
  'quaternary',
  'light',
  'dark',
  'mitsubishiYellow',
];

ColorScheme.getColorScheme = (prop, defaultColorScheme = null) => {
  const color = prop?.color === 'default' ? null : prop?.color;
  return color || defaultColorScheme;
};

ColorScheme.propTypes = {
  color: PropTypes.oneOf(COLORS),
};
ColorScheme.defaultProps = {
  color: 'default',
};

ColorScheme.graphQlSchema = `
  color
`;
